import { stateList } from "./data/constants";

const client = require("braintree-web/client");
const hostedFields = require("braintree-web/hosted-fields");
const dataCollector = require("braintree-web/data-collector");
const braintreeToken = window._braintreeToken;
const appName = window._appName;
const orderId = window._orderId;
let ccDeviceData = null;
const isCardOnFileFlow = false;
const editedPaymentMethod = false;
let braintree = { hostedFields: null, errors: {} };
let error = null;

const billingAddressSameAsShippingInput = () =>
    document.getElementById("billing-address-same-as-shipping");

const submitButton = () => document.getElementById("submit-button");
submitButton.enable = () => submitButton().removeAttribute("disabled");
submitButton.disable = () => submitButton().setAttribute("disabled", true);

const paymentFormContainer = () => document.getElementById("cc-box");

let cardFormIsValid = false;
let addressFormIsValid = true;

function setCardFormIsValid(newIsValid) {
    cardFormIsValid = newIsValid;
    if (cardFormIsValid && addressFormIsValid) {
        submitButton.enable();
    } else {
        submitButton.disable();
        paymentFormContainer().scrollIntoView();
    }
}

function setAddressFormIsValid(newIsValid) {
    addressFormIsValid = newIsValid;
    if (addressFormIsValid && cardFormIsValid) {
        submitButton.enable();
    } else {
        submitButton.disable();
        submitButton();
    }
}

function markCardElementWithError(cardElementContainer) {
    cardElementContainer.querySelector(".card-error-field")?.remove();
    const error = document.createElement("div");
    error.classList.add("card-error-field");
    error.innerText = "Please review this field.";
    cardElementContainer.appendChild(error);
    cardElementContainer.classList.add("has-error");
}

function removeCardElementError(cardElementContainer) {
    cardElementContainer.querySelector(".card-error-field")?.remove();
    cardElementContainer.classList?.remove("has-error");
}

function setError(newError) {
    error = newError;
    const errorWrap = document.getElementById("error-wrap");
    if (!error) {
        errorWrap.style.display = "none";
        return;
    }
    errorWrap.style.display = "block";
    setLoading(false);
    errorWrap.scrollIntoView();
    if (newError.type) {
        errorWrap
            .querySelector(".alert")
            .classList.add(`alert-${newError.type}`);
    } else {
        errorWrap.querySelector(".alert").classList.add("alert-error");
    }
    errorWrap.querySelector(".error-content").innerHTML = /*html*/ `<p>
        ${newError.message}
    </p>`;
}

function mountStateSelectDropdown() {
    const stateDropdown = document.getElementById("state-dropdown");
    let stateDropdownItems = /*html*/ `
    <option value="" selected disabled>Select State</option>
    `;
    Object.keys(stateList).forEach((stateAbbrev) => {
        stateDropdownItems += /*html*/ `<option ${
            stateDropdown.getAttribute("value") == stateAbbrev ? "selected" : ""
        } value="${stateAbbrev}">${stateList[stateAbbrev]}</option>`;
    });
    stateDropdown.innerHTML = stateDropdownItems;
}

function setLoading(shouldBeLoading) {
    if (shouldBeLoading) {
        submitButton.disable();
        if (window.innerWidth > 800) {
            submitButton().scrollIntoView();
        }
    }
}

function setCardHeadingColor(newColor) {
    paymentFormContainer().childNodes.forEach((e) => {
        if (e.style) {
            e.style.color = newColor;
        }
    });
}

function setCardBackground(newBackground) {
    paymentFormContainer().style.background = newBackground;
}

function checkCardType(newCardType) {
    let cardTypeFound = false;
    switch(newCardType) {
        case 'maestro':
            setCardHeadingColor("initial");
            setCardBackground("var(--cool-grey00)");
            setError({
                message: "This Card Type is Not Accepted"
            });
            break;
        case 'visa':
            setCardHeadingColor('#fff')
            setCardBackground('linear-gradient(106deg, rgba(13,74,162,1) 0%, rgba(7,37,81,1) 100%)');
            cardTypeFound = true;
            break;
        case "master-card":
        case "mastercard":
            setCardHeadingColor("#fff");
            setCardBackground(
                "linear-gradient(286deg, rgba(247,158,27,1) 0%, rgba(185,0,0,1) 100%)"
            );
            cardTypeFound = true;
            break;
        case "discover":
            setCardHeadingColor("#fff");
            setCardBackground(
                "linear-gradient(286deg, rgba(247,213,27,1) 0%, rgba(235,136,0,1) 100%)"
            );
            cardTypeFound = true;
            break;
        case "american-express":
        case "american express":
            setCardHeadingColor("#fff");
            setCardBackground(
                "linear-gradient(286deg, rgba(0,111,207,1) 0%, rgba(21,143,248,1) 100%)"
            );
            cardTypeFound = true;
            break;
        case "jcb":
            setCardHeadingColor("#fff");
            setCardBackground(
                "linear-gradient(287deg, rgba(226,1,56,1) 0%, rgba(0,104,180,1) 100%)"
            );
            cardTypeFound = true;
            break;
        case "diners-club":
        case "diners club":
            setCardHeadingColor("#fff");
            setCardBackground(
                "linear-gradient(286deg, rgba(181,181,181,1) 0%, rgba(23,73,118,1) 100%)"
            );
            cardTypeFound = true;
            break;
        case "":
        default:
            setCardHeadingColor("initial");
            setCardBackground("var(--cool-grey00)");
    }
    const logoEl = document.getElementById("cc-logo");
    const supportedPaymentMethods = document.getElementById(
        "supported-payment-methods"
    );
    if (newCardType && cardTypeFound) {
        logoEl.src = `https://media.sweetwater.com/m/marketplace/images/cc-logos/png/${newCardType.replace(
            "-",
            ""
        )}.png`;
        logoEl.style.display = "block";
        logoEl.setAttribute("alt", newCardType);
        supportedPaymentMethods.style.display = "none";
        setError(null);
    } else {
        logoEl.style.display = "none";
        supportedPaymentMethods.style.display = "flex";
    }
}

function setCardType(newCardType) {
    checkCardType(newCardType);
}

function setBraintree(newBraintree) {
    braintree = newBraintree(braintree);
}

function setCcDeviceData(newCDeviceData) {
    ccDeviceData = newCDeviceData;
}

function billingAddressSameAsShippingToggle(billingAddressSameAsShipping) {
    const newAddressInputsTemplate = document.getElementById(
        "new-address-inputs-template"
    );
    const newAddressInputsMount = document.getElementById(
        "new-address-inputs-mount"
    );

    const requiredInputs = () =>
        Array.from(newAddressInputsMount.querySelectorAll("input")).filter(
            (input) => input.hasAttribute("required")
        );

    const completedInputs = () => requiredInputs().filter((i) => i.value);

    if (billingAddressSameAsShipping) {
        newAddressInputsMount.innerHTML = "";
        if (cardFormIsValid) {
            submitButton.enable();
        }
    } else {
        newAddressInputsMount.innerHTML = newAddressInputsTemplate.innerHTML;
        submitButton.disable();
        mountStateSelectDropdown();

        Array.from(document.querySelectorAll(".form-group__error")).forEach(
            (inputElement) => {
                inputElement.addEventListener("change", (changeEvent) => {
                    changeEvent.target.classList.remove("form-group__error");
                });
            }
        );

        requiredInputs().forEach((requiredInput) => {
            requiredInput.addEventListener("input", (inputEvent) => {
                setAddressFormIsValid(
                    requiredInputs().length === completedInputs().length
                );
            });
        });
    }
}

function submitForm(e) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    braintree.hostedFields.tokenize(async function (tokenizeErr, payload) {
        const { details } = payload || { details: {} };
        document.getElementById("number-card-input").value = "";
        document.getElementById("exp_month-card-input").value =
            details.expirationMonth;
        document.getElementById("exp_year-card-input").value =
            details.expirationYear;
        document.getElementById("zip-card-input").value = "";
        if (tokenizeErr) {
            tokenizeErr &&
                tokenizeErr.details &&
                Object.values(tokenizeErr.details.invalidFields).forEach(
                    markCardElementWithError
                );

            switch (tokenizeErr.code) {
                case "HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR":
                    setError({
                        message: "Network error, please try again.",
                        type: "warning",
                    });
                    break;
                case "HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED":
                    setError({
                        message: "Invalid CVV, please check and try again.",
                        type: "error",
                    });
                    break;
                case "HOSTED_FIELDS_FIELDS_INVALID":
                    setError({
                        message:
                            "Please ensure all required data is filled out correctly.",
                        type: "error",
                    });
                    break;
                default:
                    setError({
                        message:
                            "Unable to process the card, please try a different payment method",
                        type: "error",
                    });
            }
            setLoading(false);
            return;
        }

        if (payload.nonce) {
            document.getElementById("card-braintree-data-input").value =
                JSON.stringify(payload);
            document.getElementById("card-braintree-device-data-input").value =
                ccDeviceData;
            e.target.submit();
        }
    });
}

Array.from(
    document.querySelectorAll(".product-card-accordion__expander")
).forEach(function (element) {
    element.addEventListener("click", function () {
        const productAccordion = element.parentNode,
            productAccordionStage = productAccordion.querySelector(
                ".product-card-accordion__stage"
            ),
            maxHeight = productAccordion.getAttribute("data-maxheight"),
            expanderHeight = 66;

        productAccordion.classList.toggle("product-card-accordion__expanded");

        if (
            productAccordion.classList.contains(
                "product-card-accordion__expanded"
            )
        ) {
            productAccordion.style.maxHeight =
                productAccordionStage.offsetHeight + expanderHeight + "px";
        } else {
            productAccordion.style.maxHeight = maxHeight + "px";
        }
    });
});

// billingAddressSameAsShippingToggle(billingAddressSameAsShippingInput().checked);

// billingAddressSameAsShippingInput().addEventListener("change", (e) => {
//     billingAddressSameAsShippingToggle(e.target.checked);
// });

client.create(
    {
        authorization: braintreeToken,
    },
    function (clientErr, clientInstance) {
        if (clientErr) {
            // Handle error in client creation
            return;
        }

        dataCollector.create(
            {
                client: clientInstance,
            },
            function (err, dataCollectorInstance) {
                if (!err) {
                    setCcDeviceData(dataCollectorInstance.deviceData);
                }
            }
        );

        const options = {
            client: clientInstance,
            fields: {
                number: {
                    container: "#card-number",
                    prefill: window._cardNumber,
                    placeholder: "●●●● ●●●● ●●●● ●●●●",
                    supportedCardBrands: {
                        maestro: false,
                    }
                },
                cvv: {
                    container: "#cvv",
                    placeholder: "●●●",
                },
                expirationMonth: {
                    container: "#expiration-month",
                    placeholder: "MM",
                    prefill: window._expirationMonth,
                },
                expirationYear: {
                    container: "#expiration-year",
                    placeholder: "YY",
                    prefill: window._expirationYear,
                },
                postalCode: {
                    container: "#postal-code",
                    prefill: window._postalCode,
                    placeholder: "●●●●●",
                },
            },
            styles: {
                input: {
                    "font-size": "16px",
                    color: "#575656",
                    padding: "0 10px",
                },
                "::placeholder": {
                    color: "#949595",
                    opacity: "1",
                },
            },
        };

        hostedFields.create(
            options,
            function (hostedFieldsErr, hostedFieldsInstance) {
                if (hostedFieldsErr) {
                    // Handle error in Hosted Fields creation
                    return;
                }

                // Don't prematurely set loading to false in the case of a user editing a card on file while in checkout flow
                // (Before setting loading to false, we need to check if they have active listings to determine disabling deletion. See "handleDisableDeletion")
                if (
                    !(
                        !isCardOnFileFlow &&
                        editedPaymentMethod &&
                        editedPaymentMethod.card_on_file_id
                    )
                ) {
                    setLoading(false);
                }

                hostedFieldsInstance.on("validityChange", (event) => {
                    const state = hostedFieldsInstance.getState();
                    const fieldState = state.fields[event.emittedBy];

                    if (!fieldState.isValid) {
                        markCardElementWithError(fieldState.container);
                        if (event.emittedBy === 'number') {
                            setError({
                                type: 'error',
                                message: 'This Card Type is Not Accepted',
                            });
                        }
                    } else {
                        setError(null);
                        removeCardElementError(fieldState.container);
                    }

                    const invalidFields = Object.values(state.fields).filter(
                        (f) => !f.isValid
                    );
                    setCardFormIsValid(invalidFields.length === 0);
                });

                hostedFieldsInstance.on("focus", (e) => {
                    const container = e.fields[e.emittedBy]?.container;
                    removeCardElementError(container);
                    setError(null);
                    if (e.cards.length == 1) {
                        setCardType(e.cards[0].type);
                    }
                });

                hostedFieldsInstance.on("cardTypeChange", function (event) {
                    if (event.cards.length === 1) {
                        setCardType(event.cards[0].type);
                    } else {
                        setCardType("");
                    }
                });

                // Use the Hosted Fields instance here to tokenize a card
                setBraintree((braintree) => ({
                    ...braintree,
                    hostedFields: hostedFieldsInstance,
                }));
            }
        );
    }
);

document.getElementById("form").addEventListener("submit", submitForm);
